import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { featureSelected } from "../../features/filter/filterSlice";

function FeatureFilter() {
  const dispatch = useDispatch();
  const status = useSelector((state) => state.filter);
  const { feature } = status;
  // console.log(feature);

  const filterFeaturedHandler = (e) => {
    e.preventDefault();
    dispatch(featureSelected("featured"));
  };
  const noFilterFeaturedHandler = (e) => {
    e.preventDefault();
    dispatch(featureSelected("all"));
  };
  return (
    <div className="flex items-center space-x-4">
      <button
        className={
          feature === "all" ? "lws-filter-btn active-filter" : "lws-filter-btn"
        }
        id="lws-filterAll"
        onClick={noFilterFeaturedHandler}
      >
        All
      </button>
      <button
        className={
          feature === "featured"
            ? "lws-filter-btn active-filter"
            : "lws-filter-btn"
        }
        id="lws-filterFeatured"
        onClick={filterFeaturedHandler}
      >
        Featured
      </button>
    </div>
  );
}

export default FeatureFilter;
